export const tag = 'serviceTemplate';
export const load = async () => {
    const { ServiceTemplateComponent } = await import('./service-template.component');
    return {
        component: ServiceTemplateComponent,
    };
};
